import axios, { type AxiosResponse } from '@fs/zion-axios'
import { relativesConfig } from '../../../config'
import { ORCHESTRATION_SERVICE as SERVICE } from '../../serviceNames'
import { getEnv } from '../../../lib/helpers/urlHelpers'

const { eventIds } = relativesConfig

// DOCS: https://www.familysearch.org/service/orchestration/relatives-at-event/
const BASE = `${SERVICE}/relatives-at-event/event`
const EVENT = `${BASE}/${eventIds[getEnv()]}`
const COUNTRIES = `${EVENT}/places/countries`

export const getEventAttendeeCounts = async (): Promise<AxiosResponse> => {
  return axios.get(`${EVENT}/attendees/counts`)
}
export const getRaeCountries = async (): Promise<AxiosResponse> => {
  return axios.get(`${COUNTRIES}`)
}
export const getRaeProvinces = async (countryId: string): Promise<AxiosResponse> => {
  return axios.get(`${COUNTRIES}/${countryId}/states-provinces`)
}
